import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Alert, Button, Paper, Stack, TextField, Typography,
} from '@mui/material';
import PageLayout from '../shell/PageLayout';
import brand from '../shell/brand';
import { request } from './OperationsProvider';
import { sessionActions } from '../store';

const AccountPage = () => {
  const user = useSelector((state) => state.session.user);
  const dispatch = useDispatch();
  const [name, setName] = useState(user.name);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);
  const save = async (event) => {
    event.preventDefault(); setPending(true); setError(null); setSaved(false);
    try { dispatch(sessionActions.updateUser(await request('/api/session', 'PATCH', { name }))); setSaved(true); } catch (err) { setError(err.message); } finally { setPending(false); }
  };
  return (
    <PageLayout title="My account" subtitle={`Your ${brand.name} identity and access.`}>
      <Stack gap={3} sx={{ maxWidth: 560 }}>
        <Paper component="form" onSubmit={save} variant="outlined" sx={{ p: 3 }}>
          <Stack gap={2}>
            {error && <Alert severity="error">{error}</Alert>}
            {saved && <Alert severity="success">Profile updated.</Alert>}
            <TextField required label="Name" value={name} onChange={(e) => setName(e.target.value)} />
            <Typography>{user.email}</Typography>
            <Typography color="text.secondary">{`${user.role.replaceAll('_', ' ')} · Organization ${user.tenantId}`}</Typography>
            <Button variant="contained" type="submit" disabled={pending}>Save profile</Button>
          </Stack>
        </Paper>
      </Stack>
    </PageLayout>
  );
};
export default AccountPage;
